import { getCountryCode } from '@swf/core/utils/phoneVerification';

export const composePhoneNumber = (dialingCode: string, phoneNumber: string | number) => {
  const code = getCountryCode(dialingCode)?.text.slice(1);
  return `${code}${phoneNumber}`;
};
